/*
 * BURSTkids Oral Probiotic landing page interactions.
 * Sibling to probiotic-landing.js / pro2-landing.js. Guarded against
 * double-init (the asset tag may appear once per section) and scoped to
 * `.kids-lp` roots. Data-attributes only — no inline onclick, no globals
 * that could collide with the theme or the other landing bundles.
 *
 * Ported 1:1 from the kids_probiotics_landing.html <script> logic, with the
 * offer buy box re-wired to the theme's real add-to-cart form:
 *   - "How many kids" (1/2/3) sets items[0][quantity]
 *   - "Delivery" cadence sets items[0][selling_plan] (monthly vs quarterly);
 *     one-time removes the selling_plan input name so it adds as a one-off.
 * Displayed prices come from data-* on each kid button (editable per section
 * in the schema), exactly mirroring the original P{} pricing table.
 */
(function () {
  'use strict';
  if (window.__kidsLPInit) return;
  window.__kidsLPInit = true;

  /* Lightweight analytics shim so ported burstTrack() calls never throw. */
  function burstTrack(event, data) {
    try { if (window.fbq) window.fbq('track', event, data || {}); } catch (e) {}
    try { if (window.gtag) window.gtag('event', event, data || {}); } catch (e) {}
  }

  function initOffer(root) {
    if (root.__kidsOfferInit) return;
    root.__kidsOfferInit = true;

    var kidBtns = root.querySelectorAll('.kidseg .kidbtn');
    var cadBtns = root.querySelectorAll('.cadence .cadbtn');
    var oneBtn = root.querySelector('[data-onetime]');
    if (!kidBtns.length) return;

    var elNow = root.querySelector('[data-price-now]');
    var elWas = root.querySelector('[data-price-was]');
    var elBadge = root.querySelector('[data-price-badge]');
    var elSub = root.querySelector('[data-subline]');
    var elAuto = root.querySelector('[data-autobar]');
    var elPerdaySub = root.querySelector('[data-perday-sub]');
    var elPerdayWrap = root.querySelector('[data-perday-wrap]');

    /* Real ATC hidden inputs (present only when a product is wired). */
    var qtyInput = root.querySelector('input[name="items[0][quantity]"]');
    var planInput = root.querySelector('[data-selling-plan]');
    var monthlyPlan = planInput ? planInput.getAttribute('data-monthly-plan') : '';
    var quarterlyPlan = planInput ? planInput.getAttribute('data-quarterly-plan') : '';

    /* Sticky bar mirror (rendered once inside the offer section). */
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyLabel = document.querySelector('[data-sticky-label]');

    var kids = 1, cad = 'monthly';

    function currentBtn() {
      var found = kidBtns[0];
      kidBtns.forEach(function (b) { if (+b.getAttribute('data-kids') === kids) found = b; });
      return found;
    }

    function render() {
      var b = currentBtn();
      var d = {
        perbottle: b.getAttribute('data-perbottle'),
        pct: b.getAttribute('data-pct'),
        mo_now: b.getAttribute('data-mo-now'),
        mo_was: b.getAttribute('data-mo-was'),
        mo: b.getAttribute('data-mo'),
        r_total: b.getAttribute('data-r-total'),
        r_was: b.getAttribute('data-r-was')
      };

      if (cad === 'onetime') {
        if (elNow) elNow.innerHTML = d.mo_was;
        if (elWas) elWas.style.display = 'none';
        if (elBadge) elBadge.style.display = 'none';
        if (elAuto) elAuto.style.display = 'none';
        if (elPerdayWrap) elPerdayWrap.style.display = 'none';
        if (elSub) elSub.innerHTML = 'One-time purchase · single payment, no subscription';
        if (stickyPrice) stickyPrice.innerHTML = d.mo_was + ' once';
        if (stickyLabel) stickyLabel.innerHTML = 'One-time · no subscription';
      } else {
        if (elWas) elWas.style.display = '';
        if (elBadge) elBadge.style.display = '';
        if (elAuto) elAuto.style.display = '';
        if (elPerdayWrap) elPerdayWrap.style.display = '';
        if (elBadge) elBadge.textContent = 'SAVE ' + d.pct + '%';
        if (elAuto) elAuto.innerHTML = d.pct + '% OFF AUTO-APPLIED TODAY ✓';
        if (cad === 'monthly') {
          if (elNow) elNow.innerHTML = d.mo_now;
          if (elWas) elWas.innerHTML = d.mo_was;
          if (elSub) elSub.innerHTML = d.perbottle + '/bottle on subscription · delivered fresh monthly · cancel anytime';
          if (stickyPrice) stickyPrice.innerHTML = d.mo;
          if (stickyLabel) stickyLabel.innerHTML = 'Save ' + d.pct + '% · ' + d.perbottle + '/bottle · cancel anytime';
          if (elPerdaySub) elPerdaySub.innerHTML = 'Delivered fresh monthly · cancel anytime';
        } else {
          if (elNow) elNow.innerHTML = d.r_total;
          if (elWas) elWas.innerHTML = d.r_was;
          if (elSub) elSub.innerHTML = '3-month supply, billed once · ' + d.perbottle + '/bottle · cancel renewals anytime';
          if (stickyPrice) stickyPrice.innerHTML = d.r_total + ' / 3 mo';
          if (stickyLabel) stickyLabel.innerHTML = d.perbottle + '/bottle · prepaid 90 days · cancel anytime';
          if (elPerdaySub) elPerdaySub.innerHTML = 'Billed once every 90 days · cancel anytime';
        }
      }

      /* Real ATC wiring: quantity = kids, selling plan = cadence. */
      if (qtyInput) qtyInput.value = kids;
      if (planInput) {
        if (cad === 'onetime') {
          planInput.removeAttribute('name');
        } else {
          planInput.setAttribute('name', 'items[0][selling_plan]');
          planInput.value = (cad === 'reset' ? quarterlyPlan : monthlyPlan);
        }
      }
    }

    kidBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        kids = +b.getAttribute('data-kids');
        kidBtns.forEach(function (x) { x.classList.remove('sel'); });
        b.classList.add('sel');
        render();
      });
    });
    cadBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        cad = b.getAttribute('data-cad');
        cadBtns.forEach(function (x) { x.classList.remove('sel'); });
        b.classList.add('sel');
        if (oneBtn) oneBtn.classList.remove('on');
        render();
      });
    });
    if (oneBtn) {
      oneBtn.addEventListener('click', function () {
        cad = 'onetime';
        cadBtns.forEach(function (x) { x.classList.remove('sel'); });
        oneBtn.classList.add('on');
        render();
      });
    }

    render();

    /* Fire tracking on the real ATC / sticky CTAs. */
    root.querySelectorAll('[data-offer-cta], [data-sticky-cta]').forEach(function (a) {
      a.addEventListener('click', function () {
        burstTrack('AddToCart', { content_name: 'BURSTkids Oral Probiotic', kids: kids, plan: cad });
      });
    });
  }

  function init() {
    /* ---- OFFER buy box ---- */
    document.querySelectorAll('[data-kids-offer]').forEach(initOffer);

    /* ---- Cross-sell: swatches, expand, carousel dots (document-delegated) ---- */
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('.kids-lp .xc-sw');
      if (sw) {
        var group = sw.closest('.xc-swatches');
        var img = document.getElementById(group.getAttribute('data-target'));
        var cta = document.getElementById(group.getAttribute('data-cta'));
        group.querySelectorAll('.xc-sw').forEach(function (s) { s.classList.remove('sel'); });
        sw.classList.add('sel');
        if (img && sw.getAttribute('data-img')) img.src = sw.getAttribute('data-img');
        if (cta && sw.getAttribute('data-vid')) {
          var swPlan = sw.getAttribute('data-plan'); /* per-swatch plan (flavours are separate products) */
          cta.href = '/cart/' + sw.getAttribute('data-vid') + ':1' + (swPlan ? '?selling_plan=' + swPlan : '');
          cta.setAttribute('data-vid', sw.getAttribute('data-vid'));
          if (swPlan) { cta.setAttribute('data-plan', swPlan); } else { cta.removeAttribute('data-plan'); }
          /* Out-of-stock swatch → show "Sold out" and block the add; in-stock → restore label. */
          if (sw.getAttribute('data-available') === 'false') {
            cta.textContent = 'Sold out';
            cta.setAttribute('data-soldout', '1');
            cta.classList.add('xc-add--soldout');
          } else {
            cta.textContent = cta.getAttribute('data-add-label') || 'Add to cart';
            cta.removeAttribute('data-soldout');
            cta.classList.remove('xc-add--soldout');
          }
        }
        return;
      }
      var toggle = e.target.closest('.kids-lp .xc-toggle');
      if (toggle) {
        var card = toggle.closest('.xcard');
        var open = card.classList.toggle('open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.textContent = open ? 'Hide details' : 'View details';
        return;
      }
      /* Cross-sell "Add to cart" → AJAX add + open the theme cart drawer
         (instead of navigating to the /cart permalink, which is the no-JS fallback). */
      var add = e.target.closest('.kids-lp .xc-add');
      if (add) {
        var vid = add.getAttribute('data-vid');
        if (!vid) { /* parse from the /cart/<vid>:1 fallback href */
          var m = (add.getAttribute('href') || '').match(/\/cart\/(\d+):/);
          vid = m && m[1];
        }
        if (!vid) return; /* let the link do its thing */
        e.preventDefault();
        if (add.getAttribute('data-soldout')) return; /* OOS variant selected — nothing to add */
        if (add.dataset.adding) return;
        add.dataset.adding = '1';
        var label = add.textContent;
        add.textContent = 'Adding…';
        var item = { id: Number(vid), quantity: 1 };
        var plan = add.getAttribute('data-plan'); /* subscription selling plan (from the picked product) */
        if (plan) { item.selling_plan = Number(plan); }
        var reset = function (txt, hold) {
          add.textContent = txt;
          if (hold) { setTimeout(function () { add.textContent = label; delete add.dataset.adding; }, hold); }
          else { delete add.dataset.adding; }
        };
        /* POST to /cart/add.js. fetch resolves even on 4xx, so we surface r.ok. */
        var postAdd = function (withPlan) {
          var it = { id: Number(vid), quantity: 1 };
          if (withPlan && plan) { it.selling_plan = Number(plan); }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [it] })
          }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); });
        };
        postAdd(true).then(function (res) {
          /* If the subscription plan is rejected, retry as a one-time add so the item still lands. */
          if (!res.ok && plan) {
            if (window.console) console.warn('[kids] selling plan ' + plan + ' rejected for variant ' + vid + '; retrying one-time. (' + ((res.data && res.data.description) || '') + ')');
            return postAdd(false).then(function (r2) { r2.fellBack = true; return r2; });
          }
          return res;
        }).then(function (res) {
          if (!res.ok) {
            /* genuinely bad/unavailable variant id → surface it instead of a silent empty drawer */
            if (window.console) console.warn('[kids] add-to-cart failed for variant ' + vid + ': ' + ((res.data && res.data.description) || 'unavailable'));
            reset('Sold out', 1800);
            return;
          }
          if (window.SideCart && window.SideCart.updateSideCart) {
            window.SideCart.updateSideCart(true); /* refresh + open the drawer */
          } else {
            window.location.href = '/cart';
          }
          if (typeof burstTrack === 'function') burstTrack('AddToCart', { content_name: add.closest('.xcard') && add.closest('.xcard').querySelector('.xc-name') ? add.closest('.xcard').querySelector('.xc-name').textContent : 'Cross-sell', variant_id: vid });
          reset(label);
        }).catch(function () {
          reset('Sold out', 1800); /* network error */
        });
        return;
      }
    });

    document.querySelectorAll('.kids-lp [data-xrail]').forEach(function (rail) {
      var dots = rail.parentNode.querySelector('[data-xdots]');
      if (!dots) return;
      var ds = dots.querySelectorAll('.xdot');
      var cards = rail.querySelectorAll('.xcard');
      dots.addEventListener('click', function (e) {
        var btn = e.target.closest('.xdot');
        if (!btn) return;
        var c = cards[+btn.getAttribute('data-i')];
        if (!c) return;
        var left = c.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft - (rail.clientWidth - c.offsetWidth) / 2;
        rail.scrollTo({ left: left, behavior: 'smooth' });
      });
      var tick = false;
      rail.addEventListener('scroll', function () {
        if (tick) return; tick = true;
        requestAnimationFrame(function () {
          var mid = rail.scrollLeft + rail.clientWidth / 2, idx = 0, best = 1e9;
          cards.forEach(function (c, i) { var m = c.offsetLeft + c.offsetWidth / 2; var d = Math.abs(m - mid); if (d < best) { best = d; idx = i; } });
          ds.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
          tick = false;
        });
      }, { passive: true });
    });

    /* ---- STICKY BAR ---- */
    (function () {
      var bar = document.querySelector('.kids-lp .sticky-buy');
      var hero = document.querySelector('[data-kids-hero]');
      var end = document.querySelector('[data-kids-end]') || document.querySelector('footer[role="contentinfo"]');
      if (!bar || !hero) return;
      var pastHero = false, atEnd = false;
      function update() { bar.classList.toggle('show', pastHero && !atEnd); }
      new IntersectionObserver(function (en) { pastHero = !en[0].isIntersecting; update(); }, { rootMargin: '-60px 0px 0px 0px' }).observe(hero);
      if (end) { new IntersectionObserver(function (en) { atEnd = en.some(function (x) { return x.isIntersecting; }); update(); }, { threshold: 0 }).observe(end); }
    })();

    /* ---- STICKY / on-page CTA → trigger the offer form's real add button ---- */
    document.addEventListener('click', function (e) {
      var sticky = e.target.closest('[data-sticky-cta]');
      if (sticky) {
        var addBtn = document.querySelector('[data-kids-offer] .btn.add, [data-kids-offer] button[type="submit"]');
        if (addBtn) { e.preventDefault(); addBtn.click(); }
      }
    });

    /* ---- MONSTER RITUAL: scroll-driven fade + video swap ---- */
    document.querySelectorAll('[data-kids-ritual]').forEach(function (section) {
      var steps = section.querySelectorAll('.rstep');
      var imgs = section.querySelectorAll('.rframe .rimg');
      var label = section.querySelector('[data-rit-label]');
      var media = section.querySelector('.ritual2-media');
      var names = ['Step 1 · Brush', 'Step 2 · Tablet', 'Step 3 · Bed'];
      if (!steps.length || !media) return;
      var activeIdx = -1, running = false;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* Keep every clip playing/buffering so a crossfade never reveals a cold,
         paused (blank) video. Pausing non-active clips caused videos 2 & 3 to
         show nothing when scrolled to. */
      function playAll() {
        if (reduce) return;
        imgs.forEach(function (m) { if (m.play) { var p = m.play(); if (p && p.catch) p.catch(function () {}); } });
      }
      function setActive(i) {
        if (i === activeIdx) return; activeIdx = i;
        imgs.forEach(function (m) { m.classList.toggle('on', +m.getAttribute('data-i') === i); });
        playAll();
        if (label && names[i] != null) label.innerHTML = names[i];
      }
      playAll();
      function update() {
        var vh = window.innerHeight, wide = window.innerWidth > 860, topLine, fullLine;
        if (wide) { topLine = vh * 0.13; fullLine = vh * 0.46; }
        else { var bt = media.getBoundingClientRect().bottom; topLine = bt + 16; fullLine = bt + (vh - bt) * 0.42; }
        var best = 0, bestScore = -1;
        steps.forEach(function (s, idx) {
          var r = s.getBoundingClientRect(), c = r.top + r.height * 0.5, op;
          if (c <= topLine) op = 0; else if (c >= fullLine) op = 1; else op = (c - topLine) / (fullLine - topLine);
          s.style.opacity = op.toFixed(3);
          var score = op * 1000 - Math.abs(c - fullLine) * 0.001;
          if (score > bestScore) { bestScore = score; best = idx; }
        });
        setActive(best);
      }
      function loop() { if (!running) return; update(); requestAnimationFrame(loop); }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { if (!running) { running = true; loop(); } }
          else { running = false; update(); }
        }, { threshold: 0 }).observe(section);
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });

    /* ---- HELP TABS ---- */
    document.querySelectorAll('[data-kids-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('.tab');
      var panels = root.querySelectorAll('.tp');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = t.getAttribute('data-t');
          tabs.forEach(function (x) { x.classList.toggle('on', x === t); });
          panels.forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-t') === i); });
        });
      });
    });

    /* ---- 6-THINGS ACCORDION: swap monster + colour to the open item ---- */
    document.querySelectorAll('[data-kids-acc6]').forEach(function (acc) {
      var items = acc.querySelectorAll('details');
      var scope = acc.closest('.kids-lp') || document;
      var img = scope.querySelector('[data-acc-img]');
      var media = scope.querySelector('[data-acc-media]');
      function swap(src) {
        if (!img || !src || img.getAttribute('src') === src) return;
        img.style.opacity = '0';
        var pre = new Image();
        pre.onload = function () { img.src = src; img.style.opacity = '1'; };
        pre.onerror = function () { img.src = src; img.style.opacity = '1'; };
        pre.src = src;
      }
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
          swap(d.getAttribute('data-src'));
          if (media && d.getAttribute('data-bg')) media.style.background = d.getAttribute('data-bg');
        });
      });
    });

    /* ---- PDP CAROUSEL DOTS (mobile) ---- */
    document.querySelectorAll('.kids-lp [data-pdp-track]').forEach(function (track) {
      var dots = track.parentNode.querySelectorAll('.pdp-dot');
      if (!dots.length) return;
      function setDot(i) { dots.forEach(function (d, di) { d.classList.toggle('is-on', di === i); }); }
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var i = +d.getAttribute('data-i');
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
          setDot(i);
        });
      });
      track.addEventListener('scroll', function () {
        setDot(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
      }, { passive: true });
    });

    /* ---- HYGIENIST VIDEO play ---- */
    document.querySelectorAll('[data-kids-video]').forEach(function (wrap) {
      var v = wrap.querySelector('video');
      var btn = wrap.querySelector('.vid-play');
      if (!v || !btn) return;
      btn.addEventListener('click', function () {
        v.setAttribute('controls', '');
        try { v.currentTime = 0; } catch (e) {} /* seek back to start (we preview at #t=) */
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        btn.classList.add('hide');
        burstTrack('Lead', { content_name: 'Hygienist video' });
      });
    });

    burstTrack('ViewContent', { content_name: 'BURSTkids Oral Probiotic' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
